module.exports = __webpack_public_path__ + "img/location-oosterpark.2164801c.jpg";